import { VITE_ENV_NAME } from '@/config';
import { t } from '@/i18n';

/** 環境ごとの表示ラベル。prod は環境表示自体を出さないため持たない */
const targetEnvLabelModifier = {
  local: t('target-env-local'),
  mock: t('target-env-mock'),
  dev: t('target-env-dev'),
  stg: t('target-env-stg'),
  preprod: t('target-env-preprod'),
} as const;

/**
 * 環境ごとのバナー背景色。環境の取り違えを色でも防ぐ。
 * NOTE: 本番と取り違える恐れがあるのは stg のみのため、バナーの対象は stg に限定する。
 * preprod は本番相当の作業を行う環境、dev は自動テストを prod と同じ状態で実行したい
 * 環境、local / mock は取り違えの恐れがない環境のため、いずれも対象外とする
 */
const targetEnvBannerColorModifier = {
  stg: '#d97706',
} as const;

type TargetEnv = keyof typeof targetEnvLabelModifier;

const isTargetEnv = (env: string): env is TargetEnv =>
  env in targetEnvLabelModifier;

const isTargetEnvBannerTarget = (
  env: string,
): env is keyof typeof targetEnvBannerColorModifier =>
  env in targetEnvBannerColorModifier;

/** 環境名ラベル。判別できない環境（unknown 等）はローカル扱いにフォールバックする */
export const getTargetEnvLabel = (): string =>
  isTargetEnv(VITE_ENV_NAME)
    ? targetEnvLabelModifier[VITE_ENV_NAME]
    : t('target-env-local');

/** バナー背景色。対象は stg のみで、それ以外の環境では undefined を返す */
export const getTargetEnvBannerColor = (): string | undefined =>
  isTargetEnvBannerTarget(VITE_ENV_NAME)
    ? targetEnvBannerColorModifier[VITE_ENV_NAME]
    : undefined;
